import { Button, Divider } from 'antd';
import {
  AnosFerramentas,
  Ferramenta,
  ferramentasB2B,
} from './data/ferramentas-b2b';
import Style from './ferramentas-b2b.module.css';
import { useTranslation } from 'react-i18next';

export default function FerramentasB2B() {
  const data = ferramentasB2B;
  const { t } = useTranslation(['ferramentas']);

  return (
    <div>
      {data &&
        data.map((ferramentas: AnosFerramentas) => (
          <div key={ferramentas.anoKey} className={Style.container}>
            <Divider>
              {' '}
              <h1>{t(`ferramentas:anos.${ferramentas.anoKey}` as any)}</h1>
            </Divider>
            <ul>
              {ferramentas.ferramentas.map((ferramenta: Ferramenta) => (
                <div key={ferramenta.id} className={Style.itemContainer}>
                  <hr />
                  <li className={Style.item}>
                    <img
                      onClick={() => window.open(ferramenta.link)}
                      src={ferramenta.img}
                      alt={ferramenta.img}
                    />
                    <p>{ferramenta.nome}</p>
                    <Button onClick={() => window.open(ferramenta.link)}>
                      {t('ferramentas:acesso')}
                    </Button>
                  </li>
                </div>
              ))}
            </ul>
          </div>
        ))}
    </div>
  );
}
